<template>
  <div class="container whiteBack">
    <div class="tab">
      <template v-for="(contract, index) in contracts">
        <button
          v-if="contracts.length>0"
          :key=index
          class="tablinks"
          @click="openTab($event, contract.data)">
          {{ "Documento " + contract.name }}
        </button>
      </template>
    </div>
    <vue-pdf-embed :source="selectedContract"/>
    <div class="row botonera">
      <div :class="['resumeDownloadBtn', showCancelBtn ? 'col-4' : 'col-6 only2Btns']" ><button id="downloadButton" class="resumeButtons" @click="downloadBtnClick">Descargar mi Documento</button></div>
      <div :class="['resumeAcceptBtn', showCancelBtn ? 'col-4' : 'col-6 only2Btns']" ><button id="acceptButton" class="resumeButtons" @click="greenBtnClick">{{greenBtnText}}</button> </div>
      <div class="col-4 resumeCancelBtn"  v-show="showCancelBtn"> <button id="rejectButton" class="resumeButtons" @click="cancelBtnClick">RECHAZAR</button></div>
    </div>
    <div class="textResult">
      {{btnResult}}
    </div>
    <div v-if="errorUp" class="boxPop centerCancelDiv popUpShow" ref="popError" id="popUpError">
      <error :numError="numError" v-on:closeError="closeErrorUp"/>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueResource from "vue-resource";
Vue.use(VueResource);
import settings from "@/settings";
import constants from "@/assets/environments/constants.json";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
export default {
  components: {
    VuePdfEmbed,
  },
  name: "resumeContract",
  data() {
    return {
      contracts: [],
      selectedContract: null,
      errorUp: false,
      greenBtnText:'CONTRATAR',
      showCancelBtn : false,
      isBtnActive:false,
      btnResult:'',
    };
  },
  created() {
    if (this.$session.has("setting")) {
      this.refactorEnv = this.$session.get("setting");
    }
    this.token = this.$route.params.token;
    if (this.token == undefined && this.$session.has("token")) {
      this.token = this.$session.get("token");
    }
    this.getContractInfo();
  },
  mounted() {
    this.$emit("changeVeil", false, false);
  },
  methods: {
    async getContractInfo() {
      var vm = this;
      if (this.token == undefined && this.$session.has("token")) {
        this.token = this.$session.get("token");
      }
      let urlGet = settings.getContractInfo;

      await this.$http.post(urlGet,{},{
        headers: {
            'Authorization': this.token
        }
      }).then((response) => {
        var vm = this
        var contract_list = response.body.contracts

        this.handleButtons(response.body.type, response.body.isActive)
        if(contract_list.length>0){
          for(var i = 0; contract_list.length>i ;i++){
            vm.contracts.push({"data":contract_list[i].data_file,"name":contract_list[i].name_file})
          }
        }
        this.initByDefault()
      }).catch((error) => {
          this.$emit("changeVeil", true, false);
          this.errorUp = true;
          this.numError = error.status;
          this.disabledButtons()
      });
    },
    openTab(event, contract) {
      // Declare all variables
      var i, tablinks;
      if (contract) {
        const src = constants.base64pdf + contract + '#toolbar=0';
        this.selectedContract = src;
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      event.currentTarget.className += " active";
    },
    initByDefault() {
      this.$nextTick(() => {
        if (this.contracts[0]) {
          this.selectedContract = constants.base64pdf + this.contracts[0].data+ '#toolbar=0';
          if (
            document.getElementsByClassName("tablinks") &&
            document.getElementsByClassName("tablinks")[0]
          ) {
            document.getElementsByClassName("tablinks")[0].click();
          }
        }
      });
    },
    closeErrorUp(){
      this.errorUp = false
      this.$emit('changeVeil',false, false)
    },
    async greenBtnClick(){
      let urlGet = settings.acceptContract;
      await this.$http.post(urlGet,{},{
        headers: {
            'Authorization': this.token
        }
      }).then((response) => {
        this.btnResult = constants.acceptContractText
        this.disabledButtons()
      });

    },
    async cancelBtnClick(){
      var vm = this
      let urlGet = settings.cancelContract;
      await this.$http.post(urlGet,{},{
        headers: {
            'Authorization': this.token
        }
      }).then((response) => {
        this.btnResult = constants.cancelContractText
        this.disabledButtons()
      });
    },
    downloadBtnClick(){
      this.contracts.forEach(contract => {
        const link = document.createElement('a');
        const base64Data = constants.base64pdf+contract.data;
        const mimeType = base64Data.split(';')[0].split(':')[1];
        link.href = base64Data;
        link.download = contract.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handleButtons(contractType, isActive){
      if (contractType == 'isCdv'){
          this.greenBtnText = 'CONTRATAR'
          this.showCancelBtn = false
      }
      else if(contractType =='isPortability'){
        this.greenBtnText = 'ACEPTAR'
        this.showCancelBtn = false
      }
      else if(contractType =='isPrivacity'){
        this.greenBtnText = 'ACEPTAR'
        this.showCancelBtn = true
      }
      if(!isActive){this.disabledButtons()}
    },
    disabledButtons(){
		  $("#acceptButton").prop('disabled', true);
		  $("#rejectButton").prop('disabled', true);
    }

  },
};
</script>



// WEBPACK FOOTER //
// ./src/components/resumeContract/resumeContract.vue